(ns app.front.view.admin.migration.template
  (:require [app.domain.util :as du]
            [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.ui.action-buttons :as ui-action-buttons]
            [app.front.ui.table :as ui-table]
            [app.front.util :as futil :refer [for-frag]]
            [app.front.view.group.admin.common :as acommon]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.href :as href]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::fetch-migration-tasks
  (fn [_ [_ task-id]]
    {:comm/command {:command    :admin/migration-tasks
                    :data       {:task-id task-id}
                    :method     :get
                    :on-success [::entities/merge-entity-db]}}))

(def notifications {:success "Task started, see results below."
                    :locked  "Migration is invalid and cannot be started."})

(rf/reg-event-fx ::create-migration-task
  (fn [_ [_ task-id args]]
    {:comm/command {:command    :admin/create-migration-task
                    :data       (p/assoc-if  {:task-id task-id}
                                             :args args)
                    :on-success [::create-migration-task.success]
                    :on-locked  [::start-migration-task.fail]
                    :notify     notifications}}))

(rf/reg-event-fx ::create-migration-task.success
  (fn [{:keys [db]} [_ status response]]
    {:dispatch [::entities/merge-entity-db status response]
     :db       (dissoc db ::args)}))

(rf/reg-event-fx ::approve-migration-task
  (fn [_ [_ migration-id]]
    {:comm/command {:command    :admin/approve-migration-task
                    :data       (util/mmap migration-id)
                    :on-success [::entities/merge-entity-db]
                    :on-locked  [::start-migration-task.fail]
                    :notify     notifications}}))

(rf/reg-event-fx ::start-migration-task.fail
  (fn [_ [_ _ additional-db]]
    (when (seq additional-db)
      {:dispatch [::entities/merge-entity-db 200 additional-db]})))

(rf/reg-event-fx ::cancel-migration-task
  (fn [_ [_ migration-id]]
    {:comm/command {:command    :admin/cancel-migration-task
                    :data       (util/mmap migration-id)
                    :on-success [::entities/apply-changes]
                    :notify     {:success "Task cancelled."}}}))

(rf/reg-sub ::existing-migration-tasks
  :<- [::entities/context]
  (fn [ctx [_ task-id]]
    (->> (entities/find-entities ctx {:admin-migration/task task-id})
         (sort-by :entity/created >))))

(rf/reg-event-db ::set-arg
  (fn [db [_ task-id k v]]
    (assoc-in db [::args task-id k] v)))


(rf/reg-sub ::args
  (fn [db [_ task-id]]
    (get-in db [::args task-id])))

(defn previous-runs [{:keys [tr task-id]}]
  (when-let [migrations (seq (<sub [::existing-migration-tasks task-id]))]
    (let [format-date (<sub [::date-util/date-time-fn])
          user-id     (<sub [:session/user-id])]
      [acommon/section {:title "Previously created tasks"}
       [ui-table/modern-responsive-table
        {:tr         tr
         :items      migrations
         :get-status #(case (:domain/state %)
                        :admin-migration.state/waiting-for-authorization :warning
                        :admin-migration.state/ready :ok
                        :admin-migration.state/failed :critical
                        :task)
         :cols       (concat
                       [[:domain/state
                         (comp tr vector :domain/state)]
                        [:entity/created
                         (comp format-date :entity/created)
                         {:width "180px"}]
                        [:updated
                         #(some-> % :admin-migration/updated format-date)
                         {:width "180px"}]
                        ["Arguments"
                         (comp pr-str :admin-migration/args)]
                        ["Migration id"
                         #(some-> (:db/id %)
                                  ((fn [m-id]
                                     (cc/link {:href (href/href :view/admin.entity-lookup-with-param
                                                                {:search-term m-id})} m-id))))]
                        ["Progress"
                         #(if ((du/in-state-fn :admin-migration.state/waiting-for-authorization
                                               :admin-migration.state/cancelled)
                               %)
                            "-"
                            (str (:admin-migration/processed-count % 0) " / " (:admin-migration/total-count % "?")))
                         {:width "100px"}]]
                       (when (some (du/in-state-fn :admin-migration.state/waiting-for-authorization) migrations)
                         [[""
                           (fn [{:db/keys [id] :as migration}]
                             (when (du/in-state? :admin-migration.state/waiting-for-authorization migration)
                               [ui-action-buttons/save-cancel-buttons
                                {:size           :small
                                 :on-cancel      #(>evt [::cancel-migration-task id])
                                 :on-save        #(>evt [::approve-migration-task id])
                                 :save-disabled? (-> migration :entity/creator :db/id (= user-id))
                                 :save-tr        :approve-target
                                 :tr             tr}]))
                           {:width "210px"}]]))}]])))

(defn admin-page-for-migration [{:keys [task-id args title help-text]} match]
  (let [tr       (<sub [:tr])
        arg-vals (<sub [::args task-id])]
    [acommon/admin-page (util/mmap {:title title} match)
     [acommon/section {}
      [ui/help help-text]
      [:div.flex.flex-1.flex-wrap.gap-4.items-end.justify-between
       (for-frag [{:keys [id label placeholder class]} args]
         [ui/text-input
          {:id          id
           :class       (or class "min-w-64")
           :label-text  label
           :placeholder placeholder
           :value       (get arg-vals id)
           :on-change   #(rf/dispatch-sync [::set-arg task-id id (futil/tval %)])}])
       [ui/modal-confirmation-button
        (util/mmap {:on-yes-click        (fn [_]
                                           (>evt [::create-migration-task task-id arg-vals]))
                    :trigger-button-opts {:size :field}
                    :trigger-button-text "Start task"
                    :disabled?           (->> args
                                              (map :id)
                                              (some #(str/blank? (get arg-vals %)))
                                              boolean)}
                   tr)
        [:p "Confirm that you want to start the following task: "
         [:span.bold title]]]]]
     [previous-runs (util/mmap tr task-id)]]))
